import { render } from "./B_card.vue?vue&type=template&id=5ba0485a&scoped=true"
import script from "./B_card.vue?vue&type=script&lang=js"
export * from "./B_card.vue?vue&type=script&lang=js"

import "./B_card.vue?vue&type=style&index=0&id=5ba0485a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ba0485a"]])

export default __exports__